import { Row } from 'antd'
import React from 'react'
import { useTranslation } from 'next-i18next'
import styles from './UserAdminSection.module.scss'
import type { SectionType } from '../user-admin-details.helpers'
import { CustomCol, CustomText, CustomLink } from 'src/components'

const EMPTY_TEXT = '-'

const UserAdminSection: React.FC<{ items: SectionType[] }> = ({ items }) => {
  const { t } = useTranslation()

  return <>
    {items.map((item, idx) => (
      <div key={idx}>
        {item.isVisible && <>
          <Row>
            <CustomCol xs={12}>
              <CustomText label={item.label1 || EMPTY_TEXT} />
            </CustomCol>
            <CustomCol xs={12}>
              {item.isLink ? (
                <div className='float-right'>
                  <CustomLink
                    label={item.value ? t('general.ClickHere') : EMPTY_TEXT}
                    link={item.value ? item.label2 : '#'}
                    icon={null}
                    isSmallText
                    isStrong
                  />
                </div>
              ) : (
                <CustomText
                  label={item.label2 || EMPTY_TEXT}
                  className='float-right'
                  strong
                />
              )}
            </CustomCol>
          </Row>

          {idx !== items.length - 1 && <hr className={styles.hrContent} />}
        </>}
      </div>
    ))}
  </>
}

export default UserAdminSection
